export default __webpack_public_path__ + "static/media/m_contact.1e1bef8b.png";